/* =======================================================================
 * color-functions.js
 * Version: 2.2 - updated my jQuery plugins
 * Date: 2021/01/01
 * Version: 2.1 - added selection menu for good level.
 * Date: 2018/07/23
 * Version: 2.0
 * Date: 2016/04/29
 * Version: 1.0
 * Date: 2013/04/15
 * By: Rich DeBourke
 * License: MIT
 * RGB to HSV based on: http://www.javascripter.net/faq/rgb2hsv.htm
 * HSV to RGB based on: http://snipplr.com/view/1459
 * ======================================================================= */

 (function ($, win, doc) {
    "use strict";
    var strCurrentSection;
    var instructionTargetTop;
    var aboutTargetTop;
    var $sampleText;
    var fcVal;
    var bcVal;
    var fcRVal;
    var fcGVal;
    var fcBVal;
    var bcRVal;
    var bcGVal;
    var bcBVal;
    var fcHVal;
    var fcSVal;
    var fcVVal;
    var fcOrgb;
    var fcOhsv;
    var bcHVal;
    var bcSVal;
    var bcVVal;
    var frSliderHandle;
    var fgSliderHandle;
    var fbSliderHandle;
    var fhSliderHandle;
    var fsSliderHandle;
    var fvSliderHandle;
    var foSliderHandle;
    var brSliderHandle;
    var bgSliderHandle;
    var bbSliderHandle;
    var bhSliderHandle;
    var bsSliderHandle;
    var bvSliderHandle;
    var frSliderElement;
    var fgSliderElement;
    var fbSliderElement;
    var fhSliderElement;
    var fsSliderElement;
    var fvSliderElement;
    var foSliderElement;
    var brSliderElement;
    var bgSliderElement;
    var bbSliderElement;
    var bhSliderElement;
    var bsSliderElement;
    var bvSliderElement;
    var $fcolorResult;
    var $bcolorResult;
    var $analysisDescription;
    var $cResult;
    var complianceSetting = 1;
    var $overlayComplianceLevel;
    var $complianceLevel;
    var $complianceMenu;
    var $complianceLevel1;
    var $complianceLevel2;
    var $complianceLevel3;
    var $reminderCheckBox;
    var reminderStatus = true;
    var contrastRatio;
    var bDiffVal;
    var cDiffVal;
    var w2b;
    var w2a;
    var w2aaab;
    var w2aaaa;
    var opacityColor;

    function hexValid(strHexValue) {
        var result = false;

        strHexValue = strHexValue.toUpperCase();
        if (/^[0-9A-F]{3}$|^[0-9A-F]{6}$/.test(strHexValue)) {
            result = strHexValue;
            if (strHexValue.length === 3) {
                result = strHexValue.charAt(0) + strHexValue.charAt(0) + strHexValue.charAt(1) + strHexValue.charAt(1) + strHexValue.charAt(2) + strHexValue.charAt(2);
            }
        }
        return result;
    }

    function decimalValid(valueDecimalValue) {
        var result = false;

        if (/^\d+$/.test(valueDecimalValue)) {
            result = true;
        }
        return result;
    }

    // Polyfill for Number.isNan (from MDN) as IE doesn't support the function
    Number.isNaN = Number.isNaN || function isNaN(input) {
        return typeof input === "number" && input !== input;
    };

    function hex(x) {
        var arrayHexDigits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"];

        return (
            Number.isNaN(x) ? 
            "00"
            : arrayHexDigits[(x - x % 16) / 16] + arrayHexDigits[x % 16]);
    }

    function updateRGBfromHex(foreGround) {
        var frontHex;
        var backHex;

        if (foreGround) {
            frontHex = fcVal.value;
            if (fcRVal.value !== parseInt(frontHex.substring(0, 2), 16).toString()) {
                fcRVal.value = parseInt(frontHex.substring(0, 2), 16);
            }
            if (fcGVal.value !== parseInt(frontHex.substring(2, 4), 16).toString()) {
                fcGVal.value = parseInt(frontHex.substring(2, 4), 16);
            }
            if (fcBVal.value !== parseInt(frontHex.substring(4, 6), 16).toString()) {
                fcBVal.value = parseInt(frontHex.substring(4, 6), 16);
            }
        } else {
            backHex = bcVal.value;
            if (bcRVal.value !== parseInt(backHex.substring(0, 2), 16).toString()) {
                bcRVal.value = parseInt(backHex.substring(0, 2), 16);
            }
            if (bcGVal.value !== parseInt(backHex.substring(2, 4), 16).toString()) {
                bcGVal.value = parseInt(backHex.substring(2, 4), 16);
            }
            if (bcBVal.value !== parseInt(backHex.substring(4, 6), 16).toString()) {
                bcBVal.value = parseInt(backHex.substring(4, 6), 16);
            }
        }
    }

    function updateHexFromRGB(foreGround) {
        if (foreGround) {
            fcVal.value = hex(fcRVal.value) + hex(fcGVal.value) + hex(fcBVal.value);
        } else {
            bcVal.value = hex(bcRVal.value) + hex(bcGVal.value) + hex(bcBVal.value);
        }
    }

    function updateHSVfromRGB(foreGround) {
        var d;
        var h;
        var fh;
        var fs;
        var fv;
        var bh;
        var bs;
        var bv;
        var minForeRGB;
        var maxForeRGB;
        var minBackRGB;
        var maxBackRGB;
        var fcR;
        var fcG;
        var fcB;
        var bcR;
        var bcG;
        var bcB;

        if (foreGround) {
            fcR = fcRVal.value / 255;
            fcG = fcGVal.value / 255;
            fcB = fcBVal.value / 255;
            minForeRGB = Math.min(fcR, Math.min(fcG, fcB));
            maxForeRGB = Math.max(fcR, Math.max(fcG, fcB));
            if (maxForeRGB === minForeRGB) {
                fh = 0;
                fs = 0;
                fv = maxForeRGB;
            } else {
                d = ((fcR === minForeRGB) ? fcG - fcB : ((fcB === minForeRGB) ? fcR - fcG : fcB - fcR));
                h = ((fcR === minForeRGB) ? 3 : ((fcB === minForeRGB) ? 1 : 5));
                fh = 60 * (h - d / (maxForeRGB - minForeRGB));
                fs = (maxForeRGB - minForeRGB) / maxForeRGB;
                fv = maxForeRGB;
            }
            if (fcHVal.value !== Math.round(fh).toString()) {
                fcHVal.value = Math.round(fh);
            }
            if (fcSVal.value !== Math.round(fs * 100).toString()) {
                fcSVal.value = Math.round(fs * 100);
            }
            if (fcVVal.value !== Math.round(fv * 100).toString()) {
                fcVVal.value = Math.round(fv * 100);
            }
        } else {
            bcR = bcRVal.value / 255;
            bcG = bcGVal.value / 255;
            bcB = bcBVal.value / 255;
            minBackRGB = Math.min(bcR, Math.min(bcG, bcB));
            maxBackRGB = Math.max(bcR, Math.max(bcG, bcB));
            if (maxBackRGB === minBackRGB) {
                bh = 0;
                bs = 0;
                bv = maxBackRGB;
            } else {
                d = ((bcR === minBackRGB) ? bcG - bcB : ((bcB === minBackRGB) ? bcR - bcG : bcB - bcR));
                h = ((bcR === minBackRGB) ? 3 : ((bcB === minBackRGB) ? 1 : 5));
                bh = 60 * (h - d / (maxBackRGB - minBackRGB));
                bs = (maxBackRGB - minBackRGB) / maxBackRGB;
                bv = maxBackRGB;
            }
            if (bcHVal.value !== Math.round(bh).toString()) {
                bcHVal.value = Math.round(bh);
            }
            if (bcSVal.value !== Math.round(bs * 100).toString()) {
                bcSVal.value = Math.round(bs * 100);
            }
            if (bcVVal.value !== Math.round(bv * 100).toString()) {
                bcVVal.value = Math.round(bv * 100);
            }
        }
    }

    function updateRGBfromHSV(foreGround) {
        var tmp;
        var factorial;
        var p;
        var q;
        var t;
        var foreH;
        var foreS;
        var foreV;
        var backH;
        var backS;
        var backV;

        if (foreGround) {
            foreH = parseInt(fcHVal.value, 10);
            foreS = parseInt(fcSVal.value, 10) / 100;
            foreV = parseInt(fcVVal.value, 10) / 100;

            if (foreS === 0) {
                tmp = Math.round(foreV * 255);
                fcRVal.value = tmp.toString();
                fcGVal.value = tmp.toString();
                fcBVal.value = tmp.toString();
            } else {
                if (foreH === 360) {
                    foreH = 0;
                }
                foreH = foreH / 60;
                tmp = Math.floor(foreH);
                factorial = foreH - tmp; // factorial part of h
                p = foreV * (1 - foreS);
                q = foreV * (1 - foreS * factorial);
                t = foreV * (1 - foreS * (1 - factorial));
                switch (tmp) {
                case 0:
                    fcRVal.value = Math.round(foreV * 255).toString();
                    fcGVal.value = Math.round(t * 255).toString();
                    fcBVal.value = Math.round(p * 255).toString();
                    break;
                case 1:
                    fcRVal.value = Math.round(q * 255).toString();
                    fcGVal.value = Math.round(foreV * 255).toString();
                    fcBVal.value = Math.round(p * 255).toString();
                    break;
                case 2:
                    fcRVal.value = Math.round(p * 255).toString();
                    fcGVal.value = Math.round(foreV * 255).toString();
                    fcBVal.value = Math.round(t * 255).toString();
                    break;
                case 3:
                    fcRVal.value = Math.round(p * 255).toString();
                    fcGVal.value = Math.round(q * 255).toString();
                    fcBVal.value = Math.round(foreV * 255).toString();
                    break;
                case 4:
                    fcRVal.value = Math.round(t * 255).toString();
                    fcGVal.value = Math.round(p * 255).toString();
                    fcBVal.value = Math.round(foreV * 255).toString();
                    break;
                default: // case 5:
                    fcRVal.value = Math.round(foreV * 255).toString();
                    fcGVal.value = Math.round(p * 255).toString();
                    fcBVal.value = Math.round(q * 255).toString();
                }
            }
        } else {
            backH = parseInt(bcHVal.value, 10);
            backS = parseInt(bcSVal.value, 10) / 100;
            backV = parseInt(bcVVal.value, 10) / 100;

            if (backS === 0) {
                tmp = Math.round(backV * 255);
                bcRVal.value = tmp.toString();
                bcGVal.value = tmp.toString();
                bcBVal.value = tmp.toString();
            } else {
                if (backH === 360) {
                    backH = 0;
                }
                backH = backH / 60;
                tmp = Math.floor(backH);
                factorial = backH - tmp; // factorial part of h
                p = backV * (1 - backS);
                q = backV * (1 - backS * factorial);
                t = backV * (1 - backS * (1 - factorial));
                switch (tmp) {
                case 0:
                    bcRVal.value = Math.round(backV * 255).toString();
                    bcGVal.value = Math.round(t * 255).toString();
                    bcBVal.value = Math.round(p * 255).toString();
                    break;
                case 1:
                    bcRVal.value = Math.round(q * 255).toString();
                    bcGVal.value = Math.round(backV * 255).toString();
                    bcBVal.value = Math.round(p * 255).toString();
                    break;
                case 2:
                    bcRVal.value = Math.round(p * 255).toString();
                    bcGVal.value = Math.round(backV * 255).toString();
                    bcBVal.value = Math.round(t * 255).toString();
                    break;
                case 3:
                    bcRVal.value = Math.round(p * 255).toString();
                    bcGVal.value = Math.round(q * 255).toString();
                    bcBVal.value = Math.round(backV * 255).toString();
                    break;
                case 4:
                    bcRVal.value = Math.round(t * 255).toString();
                    bcGVal.value = Math.round(p * 255).toString();
                    bcBVal.value = Math.round(backV * 255).toString();
                    break;
                default: // case 5:
                    bcRVal.value = Math.round(backV * 255).toString();
                    bcGVal.value = Math.round(p * 255).toString();
                    bcBVal.value = Math.round(q * 255).toString();
                }
            }
        }
    }

    function updateSliderPositions(foreGround) {
        // Values in the text boxes are calculated
        // Sliders are updated only if the value has changed

        if (arguments.length === 0 || foreGround) {
            if (frSliderElement.value !== fcRVal.value) {
                frSliderHandle.update(fcRVal.value);
            }
            if (fgSliderElement.value !== fcGVal.value) {
                fgSliderHandle.update(fcGVal.value);
            }
            if (fbSliderElement.value !== fcBVal.value) {
                fbSliderHandle.update(fcBVal.value);
            }
            if (fhSliderElement.value !== fcHVal.value) {
                fhSliderHandle.update(fcHVal.value);
            }
            if (fsSliderElement.value !== fcSVal.value) {
                fsSliderHandle.update(fcSVal.value);
            }
            if (fvSliderElement.value !== fcVVal.value) {
                fvSliderHandle.update(fcVVal.value);
            }
            if (foSliderElement.value !== fcOrgb.value) {
                foSliderHandle.update(fcOrgb.value);
            }
        }
        if (arguments.length === 0 || !foreGround) {
            if (brSliderElement.value !== bcRVal.value) {
                brSliderHandle.update(bcRVal.value);
            }
            if (bgSliderElement.value !== bcGVal.value) {
                bgSliderHandle.update(bcGVal.value);
            }
            if (bbSliderElement.value !== bcBVal.value) {
                bbSliderHandle.update(bcBVal.value);
            }
            if (bhSliderElement.value !== bcHVal.value) {
                bhSliderHandle.update(bcHVal.value);
            }
            if (bsSliderElement.value !== bcSVal.value) {
                bsSliderHandle.update(bcSVal.value);
            }
            if (bvSliderElement.value !== bcVVal.value) {
                bvSliderHandle.update(bcVVal.value);
            }
        }
    }

    function updateOpacitySliderPosition() {
        if (foSliderElement.value !== fcOrgb.value) {
            foSliderHandle.update(fcOrgb.value);
        }
    }

    function updateRGBfromSliders(sliderId) {
        switch (sliderId) {
        case frSliderElement.id:
            fcRVal.value = frSliderElement.value;
            break;
        case fgSliderElement.id:
            fcGVal.value = fgSliderElement.value;
            break;
        case fbSliderElement.id:
            fcBVal.value = fbSliderElement.value;
            break;
        case brSliderElement.id:
            bcRVal.value = brSliderElement.value;
            break;
        case bgSliderElement.id:
            bcGVal.value = bgSliderElement.value;
            break;
        default:
            bcBVal.value = bbSliderElement.value;
        }
    }

    function updateHSVfromSliders(foreGround) {
        if (foreGround) {
            if (fcHVal.value !== fhSliderElement.value) {
                fcHVal.value = fhSliderElement.value;
            }
            if (fcSVal.value !== fsSliderElement.value) {
                fcSVal.value = fsSliderElement.value;
            }
            if (fcVVal.value !== fvSliderElement.value) {
                fcVVal.value = fvSliderElement.value;
            }
        } else {
            if (bcHVal.value !== bhSliderElement.value) {
                bcHVal.value = bhSliderElement.value;
            }
            if (bcSVal.value !== bsSliderElement.value) {
                bcSVal.value = bsSliderElement.value;
            }
            if (bcVVal.value !== bvSliderElement.value) {
                bcVVal.value = bvSliderElement.value;
            }
        }
    }

    function updateColorsDisplay(foreGround) {
        var fore;
        var back;

        if (arguments.length === 0) {
            fore = "#" + fcVal.value;
            back = "#" + bcVal.value;
            $analysisDescription.css({"color": fore, "background-color": back});
            $fcolorResult.css("background-color", fore);
            $bcolorResult.css("background-color", back);
        } else if (foreGround) {
            fore = "#" + fcVal.value;
            $analysisDescription.css("color", fore);
            $fcolorResult.css("background-color", fore);
        } else {
            back = "#" + bcVal.value;
            $analysisDescription.css("background-color", back);
            $bcolorResult.css("background-color", back);
        }
    }

    function updateOpacityDisplay(opacity) {
        $sampleText.css("opacity", opacity / 100);
    }

    function getLuminance(rgb) {
        var i;
        var lum;

        for (i = 0; i < rgb.length; i++) {
            if (rgb[i] <= 0.03928) {
                rgb[i] = rgb[i] / 12.92;
            } else {
                rgb[i] = Math.pow(((rgb[i] + 0.055) / 1.055), 2.4);
            }
        }
        lum = (0.2126 * rgb[0]) + (0.7152 * rgb[1]) + (0.0722 * rgb[2]);
        return lum;
    }

    function updateCalculations() {
        var brightnessThreshold = 125;
        var colorThreshold = 500;
        var colorBrightnessFore;
        var colorBrightnessBack;
        var brightnessDifference;
        var colorDifference;
        var fcRi = parseInt(fcRVal.value, 10);
        var fcGi = parseInt(fcGVal.value, 10);
        var fcBi = parseInt(fcBVal.value, 10);
        var fcO = parseInt(fcOrgb.value, 10) / 100;
        var bcR = parseInt(bcRVal.value, 10);
        var bcG = parseInt(bcGVal.value, 10);
        var bcB = parseInt(bcBVal.value, 10);
        var fcR = Math.round(fcO * fcRi + (1 - fcO) * bcR);
        var fcG = Math.round(fcO * fcGi + (1 - fcO) * bcG);
        var fcB = Math.round(fcO * fcBi + (1 - fcO) * bcB);
        var lumForInitial;
        var lumFore;
        var lumBack;
        var ratio;

        opacityColor.textContent = (hex(fcR) + hex(fcG) + hex(fcB));

        colorBrightnessFore = ((fcR * 299) + (fcG * 587) + (fcB * 114)) / 1000;
        colorBrightnessBack = ((bcR * 299) + (bcG * 587) + (bcB * 114)) / 1000;
        brightnessDifference = Math.abs(colorBrightnessFore - colorBrightnessBack);
        colorDifference = (Math.max(fcR, bcR) - Math.min(fcR, bcR)) + (Math.max(fcG, bcG) - Math.min(fcG, bcG)) + (Math.max(fcB, bcB) - Math.min(fcB, bcB));
        if (bDiffVal.textContent !== brightnessDifference.toFixed(0).toString()) {
            bDiffVal.textContent = brightnessDifference.toFixed(0);
        }
        if (cDiffVal.textContent !== colorDifference.toFixed(0).toString()) {
            cDiffVal.textContent = colorDifference.toFixed(0);
        }

        /* WCAG2 Section */
        lumForInitial = getLuminance([fcRi / 255, fcGi / 255, fcBi / 255]);
        lumFore = getLuminance([fcR / 255, fcG / 255, fcB / 255]);
        lumBack = getLuminance([bcR / 255, bcG / 255, bcB / 255]);

        if (lumFore >= lumBack) {
            ratio = (lumFore + 0.05) / (lumBack + 0.05);
        } else {
            ratio = (lumBack + 0.05) / (lumFore + 0.05);
        }
        if ((lumForInitial > 0.215) && ($fcolorResult.css("color") === "rgb(255, 255, 255)")) {
            $fcolorResult.css("color", "#000000");
        } else if ((lumForInitial <= 0.215) && ($fcolorResult.css("color") === "rgb(0, 0, 0)")) {
            $fcolorResult.css("color", "#FFFFFF");
        }

        if ((lumBack > 0.215) && ($bcolorResult.css("color") === "rgb(255, 255, 255)")) {
            $bcolorResult.css("color", "#000000");
        } else if ((lumBack <= 0.215) && ($bcolorResult.css("color") === "rgb(0, 0, 0)")) {
            $bcolorResult.css("color", "#FFFFFF");
        }

        ratio = Math.round(ratio * 10) / 10;
        if (contrastRatio.textContent !== (ratio.toFixed(1) + ":1")) {
            contrastRatio.textContent = ratio.toFixed(1) + ":1";
        }

        if (w2aaab.textContent !== (ratio >= 7 ?
            "YES"
            : "NO")) {
            if (ratio >= 7) {
                w2aaab.textContent = "YES";
                w2aaab.style.backgroundColor = "#7DFF7D";
            } else {
                w2aaab.textContent = "NO";
                w2aaab.style.backgroundColor = "#FF7D7D";
            }
        }
        if (w2aaaa.textContent !== (ratio >= 4.5 ?
            "YES"
            : "NO")) {
            if (ratio >= 4.5) {
                w2aaaa.textContent = "YES";
                w2aaaa.style.backgroundColor = "#7DFF7D";
            } else {
                w2aaaa.textContent = "NO";
                w2aaaa.style.backgroundColor = "#FF7D7D";
            }
        }
        if (w2b.textContent !== (ratio >= 4.5 ?
            "YES"
            : "NO")) {
            if (ratio >= 4.5) {
                w2b.textContent = "YES";
                w2b.style.backgroundColor = "#7DFF7D";
            } else {
                w2b.textContent = "NO";
                w2b.style.backgroundColor = "#FF7D7D";
            }
        }
        if (w2a.textContent !== (ratio >= 3 ?
            "YES"
            : "NO")) {
            if (ratio >= 3) {
                w2a.textContent = "YES";
                w2a.style.backgroundColor = "#7DFF7D";
            } else {
                w2a.textContent = "NO";
                w2a.style.backgroundColor = "#FF7D7D";
            }
        }

        if (complianceSetting === 1) {
            if ((brightnessDifference >= brightnessThreshold) && (colorDifference >= colorThreshold) && (ratio >= 7.0)) {
                if ($cResult.css("background-color") !== "rgb(125, 255, 125)") {
                    $cResult.html("Good").css("background-color", "#7DFF7D");
                    $complianceLevel.css("background-color", "#7DFF7D");
                }
            } else if (ratio < 4.5) {
                if ($cResult.css("background-color") !== "rgb(255, 125, 125)") {
                    $cResult.html("Poor").css("background-color", "#FF7D7D");
                    $complianceLevel.css("background-color", "#FF7D7D");
                }
            } else {
                if ($cResult.css("background-color") !== "rgb(255, 255, 0)") {
                    $cResult.html("Okay").css("background-color", "#FFFF00");
                    $complianceLevel.css("background-color", "#FFFF00");
                }
            }
        } else if (complianceSetting === 2) {
            if (ratio >= 7.0) {
                if ($cResult.css("background-color") !== "rgb(125, 255, 125)") {
                    $cResult.html("Good").css("background-color", "#7DFF7D");
                    $complianceLevel.css("background-color", "#7DFF7D");
                }
            } else if (ratio < 4.5) {
                if ($cResult.css("background-color") !== "rgb(255, 125, 125)") {
                    $cResult.html("Poor").css("background-color", "#FF7D7D");
                    $complianceLevel.css("background-color", "#FF7D7D");
                }
            } else {
                if ($cResult.css("background-color") !== "rgb(255, 255, 0)") {
                    $cResult.html("Okay").css("background-color", "#FFFF00");
                    $complianceLevel.css("background-color", "#FFFF00");
                }
            }
        } else {
            if (ratio >= 4.5) {
                if ($cResult.css("background-color") !== "rgb(125, 255, 125)") {
                    $cResult.html("Good").css("background-color", "#7DFF7D");
                    $complianceLevel.css("background-color", "#7DFF7D");
                }
            } else if (ratio < 3.0) {
                if ($cResult.css("background-color") !== "rgb(255, 125, 125)") {
                    $cResult.html("Poor").css("background-color", "#FF7D7D");
                    $complianceLevel.css("background-color", "#FF7D7D");
                }
            } else {
                if ($cResult.css("background-color") !== "rgb(255, 255, 0)") {
                    $cResult.html("Okay").css("background-color", "#FFFF00");
                    $complianceLevel.css("background-color", "#FFFF00");
                }
            }
        }
    }

    function complianceLevel(event) {
        var complianceData;
        var reminderData;

        function setCompliance(level) {
            switch (level) {
            case 1:
                complianceSetting = 1;
                $(".comp-select").removeClass("selected");
                $complianceLevel1.addClass("selected");
                $(".analysis-description").css("display", "none");
                $("#rating-1").css("display", "block");
                break;
            case 2:
                complianceSetting = 2;
                $(".comp-select").removeClass("selected");
                $complianceLevel2.addClass("selected");
                $(".analysis-description").css("display", "none");
                $("#rating-2").css("display", "block");
                break;
            default: // case 3:
                complianceSetting = 3;
                $(".comp-select").removeClass("selected");
                $complianceLevel3.addClass("selected");
                $(".analysis-description").css("display", "none");
                $("#rating-3").css("display", "block");
            }
        }

        if (typeof event === "string") {
            // initiate - check for localStorage, if yes, load, otherwise go with default
            // Thought about notice for new feature, but decided to skip it
            if (Storage !== "undefined") {
                reminderData = JSON.parse(win.localStorage.getItem("SBF_reminder"));
                if (reminderData) {
                    if (reminderData === "remind") {
                        reminderStatus = true;
                    } else {
                        reminderStatus = false;
                    }
                }
                complianceData = JSON.parse(win.localStorage.getItem("SBF_level"));
                if (complianceData) {
                    setCompliance(complianceData);
                    JSON.parse(win.localStorage.getItem("SBF_level"));
                    if (reminderStatus === true) {
                        if (complianceData === 2) {
                            win.alert("Good|Okay|Poor is currently set to WCAG 2.0 AAA\n\nUncheck the reminder to not be reminded again");
                        } else if (complianceData === 3) {
                            win.alert("Good|Okay|Poor is currently set to WCAG 2.0 AA\n\nUncheck the reminder to not be reminded again");
                        }
                    }
                }
            } // else - if there is no localStorage then leave reminderStatus and
              // complianceData at their default values
            $reminderCheckBox.prop("checked", reminderStatus);
        } else { // one of the compliance level buttons was pressed
            event.stopPropagation();
            setCompliance(event.data.level);
            $overlayComplianceLevel.hide();
            $complianceLevel.removeClass("flip");
            $complianceMenu.slideUp();
            win.localStorage.setItem("SBF_level", JSON.stringify(event.data.level));
        }

        // I put update here so the Good display will be updated if there is a change
        // in the settings
        updateCalculations();
    }

    function changeNotice(event) {
        if (doc.getElementById(event.currentTarget.id).checked) {
            // It's checked
            reminderStatus = true;
            win.localStorage.setItem("SBF_reminder", JSON.stringify("remind"));
        } else {
            reminderStatus = false;
            win.localStorage.setItem("SBF_reminder", JSON.stringify("quiet"));
        }
    }

    function hexInputBoxChanged(event) {
        var validHexInput = hexValid(event.currentTarget.value);
        var foreGround = true;


        event.target.blur();

        if (event.target.id.charAt(0) !== "f") {
            foreGround = false;
        }

        if (validHexInput) {
            event.currentTarget.value = validHexInput;
            updateRGBfromHex(foreGround);
            updateHSVfromRGB(foreGround);
            updateColorsDisplay(foreGround);
            updateSliderPositions(foreGround);
            updateCalculations();
        } else {
            updateHexFromRGB(foreGround);
        }
    }

    function rgbInputBoxChanged(event) {
        var value = parseInt(event.currentTarget.value, 10);
        var foreGround = true;

        event.target.blur();

        if (event.target.id.charAt(0) !== "f") {
            foreGround = false;
        }

        if (decimalValid(event.currentTarget.value) && (value >= 0 && value <= 255)) {
            event.currentTarget.value = value.toString();
            updateHexFromRGB(foreGround);
            updateHSVfromRGB(foreGround);
            updateColorsDisplay(foreGround);
            updateSliderPositions(foreGround);
            updateCalculations();
        } else {
            updateRGBfromHex(foreGround);
        }
    }

    function hueInputBoxChanged(event) {
        var value = parseInt(event.currentTarget.value, 10);
        var foreGround = true;

        event.target.blur();

        if (event.target.id.charAt(0) !== "f") {
            foreGround = false;
        }

        if (decimalValid(event.currentTarget.value) && (value >= 0 && value <= 360)) {
            event.currentTarget.value = value.toString();
            updateRGBfromHSV(foreGround);
            updateHexFromRGB(foreGround);
            updateColorsDisplay(foreGround);
            updateSliderPositions(foreGround);
            updateCalculations();
        } else {
            updateHSVfromRGB(foreGround);
        }
    }

    function svInputBoxChanged(event) {
        var value = parseInt(event.currentTarget.value, 10);
        var foreGround = true;

        event.target.blur();

        if (event.target.id.charAt(0) !== "f") {
            foreGround = false;
        }

        if (decimalValid(event.currentTarget.value) && (value >= 0 && value <= 100)) {
            event.currentTarget.value = value.toString();
            updateRGBfromHSV(foreGround);
            updateHexFromRGB(foreGround);
            updateColorsDisplay(foreGround);
            updateSliderPositions(foreGround);
            updateCalculations();
        } else {
            updateHSVfromRGB(foreGround);
        }
    }

    function opacityInputBoxChangedRGB(event) {
        var value = parseInt(event.currentTarget.value, 10);

        event.target.blur();

        if (decimalValid(event.currentTarget.value) && (value >= 0 && value <= 100)) {
            if (fcOrgb.value !== value.toString()) {
                fcOrgb.value = value.toString();
            } else {
                fcOhsv.value = value.toString();
            }
            updateOpacityDisplay(value);
            updateOpacitySliderPosition();
            updateCalculations();
        } else {
            fcOrgb.value = fcOhsv.value;
        }
    }

    function opacityInputBoxChangedHSV(event) {
        var value = parseInt(event.currentTarget.value, 10);

        event.target.blur();

        if (decimalValid(event.currentTarget.value) && (value >= 0 && value <= 100)) {
            if (fcOrgb.value !== value.toString()) {
                fcOrgb.value = value.toString();
            } else {
                fcOhsv.value = value.toString();
            }
            updateOpacityDisplay(value);
            updateOpacitySliderPosition();
            updateCalculations();
        } else {
            fcOhsv.value = fcOrgb.value;
        }
    }

    function rgbSliderMoved(sliderDataObject) {
        var foreGround = true;

        if (sliderDataObject.id.charAt(0) !== "f") {
            foreGround = false;
        }
        updateRGBfromSliders(sliderDataObject.id);
        updateHexFromRGB(foreGround);
        updateHSVfromRGB(foreGround);
        updateColorsDisplay(foreGround);
        updateSliderPositions(foreGround);
        updateCalculations();
    }

    function hsvSliderMoved(sliderDataObject) {
        var foreGround = true;

        if (sliderDataObject.id.charAt(0) !== "f") {
            foreGround = false;
        }
        updateHSVfromSliders(foreGround);
        updateRGBfromHSV(foreGround);
        updateHexFromRGB(foreGround);
        updateColorsDisplay(foreGround);
        updateSliderPositions(foreGround);
        updateCalculations();
    }

    function opacitySliderMoved(sliderDataObject) {
        fcOrgb.value = sliderDataObject.value;
        fcOhsv.value = sliderDataObject.value;
        updateOpacityDisplay(sliderDataObject.value);
        updateCalculations();
    }

    function rgb2hex(rgb) {
        rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        return hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }

    function saveColorsToStorage() {
        var value = "#" + rgb2hex($("#color-sample-1").css("background-color")) + ",#" +
                rgb2hex($("#color-sample-2").css("background-color")) + ",#" +
                rgb2hex($("#color-sample-3").css("background-color")) + ",#" +
                rgb2hex($("#color-sample-4").css("background-color")) + ",#" +
                rgb2hex($("#color-sample-5").css("background-color"));

        // Note - localStorage only works on http for IE & Edge
        win.localStorage.setItem("SBF_colors", JSON.stringify(value));
    }

    function loadColorsFromStorage() {
        var colorData;

        // Load from storage - Note - localStorage only works on http for IE & Edge
        if (Storage !== "undefined") {
            colorData = JSON.parse(win.localStorage.getItem("SBF_colors"));
            if (colorData) {
                colorData = colorData.split(",");
                $("#color-sample-1").css("background-color", colorData[0]);
                $("#color-sample-2").css("background-color", colorData[1]);
                $("#color-sample-3").css("background-color", colorData[2]);
                $("#color-sample-4").css("background-color", colorData[3]);
                $("#color-sample-5").css("background-color", colorData[4]);
            } else {
                saveColorsToStorage(); // Save for the first time
            }
        }
    }

    function resetColorComboBorders() {
        $(".color-combo").css("border-color", "#585858");
    }

    function handleDropEvent($src, $dst) {
        var color = $src.css("backgroundColor");
        var foreGround = true;

        $dst.css("backgroundColor", color);
        if ($dst.hasClass("color-result")) {
            if ($dst.attr("id") === "fcolor-result") {
                fcVal.value = rgb2hex(color);
            } else {
                bcVal.value = rgb2hex(color);
                foreGround = false;
            }
            updateRGBfromHex(foreGround);
            updateHSVfromRGB(foreGround);
            updateColorsDisplay(foreGround);
            updateSliderPositions(foreGround);
            updateCalculations();
        } else {
            saveColorsToStorage();
            resetColorComboBorders();
        }
    }

    function scrollMonitor() {
        /* Monitor the scroll position, and if far enough down the page, change the navigation */
        var currentTop = win.pageYOffset || (doc.documentElement && doc.documentElement.scrollTop) || doc.body.scrollTop;

        if (currentTop < instructionTargetTop) {
            // top section
            if (strCurrentSection !== "analyzer") {
                strCurrentSection = "analyzer";
                $(".active").removeClass("active");
                $("#nav-analyzer").addClass("active");
            }
        } else if (currentTop > aboutTargetTop) {
            // bottom section$
            if (strCurrentSection !== "about") {
                strCurrentSection = "about";
                $(".active").removeClass("active");
                $("#nav-about").addClass("active");
            }
        } else {
            // middle section
            if (strCurrentSection !== "instructions") {
                strCurrentSection = "instructions";
                $(".active").removeClass("active");
                $("#nav-instructions").addClass("active");
            }
        }
    }

    function loadCalculatedColors(arrayOfColors) {
        if (arrayOfColors.length >= 1) {
            $("#color-sample-2").css("background-color", arrayOfColors[0]);
        }
        if (arrayOfColors.length >= 2) {
            $("#color-sample-3").css("background-color", arrayOfColors[1]);
        }
        if (arrayOfColors.length >= 3) {
            $("#color-sample-4").css("background-color", arrayOfColors[2]);
        }
        if (arrayOfColors.length >= 4) {
            $("#color-sample-5").css("background-color", arrayOfColors[3]);
        }
    }

    function rgb2hsl(arrayRGB) {
        var tmp = arrayRGB.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        var r;
        var g;
        var b;
        var max;
        var min;
        var h;
        var s;
        var l;
        var d;
        r = tmp[1] / 255;
        g = tmp[2] / 255;
        b = tmp[3] / 255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;

        if (max === min) {
            h = 0;
            s = 0; // achromatic
        } else {
            d = max - min;
            s = (l > 0.5 ? d / (2 - max - min) : d / (max + min));
            switch (max) {
            case r:
                h = ((g - b) / d) + (g < (b ? 6 : 0));
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            default: // case b:
                h = (r - g) / d + 4;
            }
            h = h / 6;
        }

        return [Math.round(h * 360), Math.round(s * 100), Math.round(l * 100)];
    }

    function hue2rgb(p, q, t) {
        if (t < 0) {
            t += 1;
        } else if (t > 1) {
            t -= 1;
        }

        if (t < 1 / 6) {
            return p + (q - p) * 6 * t;
        } else if (t < 1 / 2) {
            return q;
        } else if (t < 2 / 3) {
            return p + (q - p) * (2 / 3 - t) * 6;
        } else {
            return p;
        }
    }

    function hsl2hex(arrayHSL) { // was h s l
        var h;
        var s;
        var l;
        var r;
        var g;
        var b;
        var q;
        var p;

        h = arrayHSL[0] / 360;
        s = arrayHSL[1] / 100;
        l = arrayHSL[2] / 100;

        if (s === 0) {
            r = 1;
            g = 1;
            b = l; // achromatic
        } else {
            q = (l < 0.5 ? l * (1 + s) : l + s - s * l);
            p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }

        return "#" + hex(Math.round(r * 255)) + hex(Math.round(g * 255)) + hex(Math.round(b * 255));
    }

    function polarCord(h) {
        if (h > 360) {
            h = h - 360;
        } else if (h < 0) {
            h = h + 360;
        }
        return h;
    }

    function complementary() {
        var masterColor;
        var colorArray = ["#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"];

        if ($("#color-combo-1").css("border-top-color").toString() === "rgb(88, 88, 88)") {
            $(".color-combo").css("border-color", "#585858");
            $("#color-combo-1").css("border-color", "#FF0000");
            masterColor = $("#color-sample-1").css("background-color");  // Color comes through as an RGB definition)
            masterColor = rgb2hsl(masterColor);
            masterColor[0] = polarCord(masterColor[0] + 180); // Complementary color is 180 degrees from the master color
            colorArray[0] = hsl2hex(masterColor);
            loadCalculatedColors(colorArray);
        } else {
            resetColorComboBorders();
            loadColorsFromStorage();
        }
    }

    function analogous() {
        var masterColor;
        var colorArray = ["#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"];

        if ($("#color-combo-2").css("border-top-color").toString() === "rgb(88, 88, 88)") {
            $(".color-combo").css("border-color", "#585858");
            $("#color-combo-2").css("border-color", "#FF0000");
            masterColor = $("#color-sample-1").css("background-color");  // Color comes through as an RGB definition)
            masterColor = rgb2hsl(masterColor);
            masterColor[0] = polarCord(masterColor[0] + 30); // One analogus color is +30 degrees from the master color
            colorArray[0] = hsl2hex(masterColor);
            masterColor[0] = polarCord(masterColor[0] - 60); // Other analogus color is -30 degrees from the master color
            colorArray[1] = hsl2hex(masterColor);
            loadCalculatedColors(colorArray);
        } else {
            resetColorComboBorders();
            loadColorsFromStorage();
        }
    }

    function split() {
        var masterColor;
        var colorArray = ["#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"];

        if ($("#color-combo-3").css("border-top-color").toString() === "rgb(88, 88, 88)") {
            $(".color-combo").css("border-color", "#585858");
            $("#color-combo-3").css("border-color", "#FF0000");
            masterColor = $("#color-sample-1").css("background-color");  // Color comes through as an RGB definition)
            masterColor = rgb2hsl(masterColor);
            masterColor[0] = polarCord(masterColor[0] + 150); // One split color is +150 degrees from the master color
            colorArray[0] = hsl2hex(masterColor);
            masterColor[0] = polarCord(masterColor[0] + 60); // Other analogus color is -150 degrees from the master color
            colorArray[1] = hsl2hex(masterColor);
            loadCalculatedColors(colorArray);
        } else {
            resetColorComboBorders();
            loadColorsFromStorage();
        }
    }

    function triadic() {
        var masterColor;
        var colorArray = ["#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"];

        if ($("#color-combo-4").css("border-top-color").toString() === "rgb(88, 88, 88)") {
            $(".color-combo").css("border-color", "#585858");
            $("#color-combo-4").css("border-color", "#FF0000");
            masterColor = $("#color-sample-1").css("background-color");  // Color comes through as an RGB definition)
            masterColor = rgb2hsl(masterColor);
            masterColor[0] = polarCord(masterColor[0] + 240); // One split color is +60 degrees from the master color
            colorArray[0] = hsl2hex(masterColor);
            masterColor[0] = polarCord(masterColor[0] - 120); // Other analogus color is -60 degrees from the master color
            colorArray[1] = hsl2hex(masterColor);
            loadCalculatedColors(colorArray);
        } else {
            resetColorComboBorders();
            loadColorsFromStorage();
        }
    }

    function tetradic() {
        var masterColor;
        var colorArray = ["#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"];

        if ($("#color-combo-5").css("border-top-color").toString() === "rgb(88, 88, 88)") {
            $(".color-combo").css("border-color", "#585858");
            $("#color-combo-5").css("border-color", "#FF0000");
            masterColor = $("#color-sample-1").css("background-color");  // Color comes through as an RGB definition)
            masterColor = rgb2hsl(masterColor);
            masterColor[0] = polarCord(masterColor[0] + 60);
            colorArray[0] = hsl2hex(masterColor);
            masterColor[0] = polarCord(masterColor[0] + 120);
            colorArray[1] = hsl2hex(masterColor);
            masterColor[0] = polarCord(masterColor[0] + 60);
            colorArray[2] = hsl2hex(masterColor);
            loadCalculatedColors(colorArray);
        } else {
            resetColorComboBorders();
            loadColorsFromStorage();
        }
    }


    /* Setup the document objects:
        Set the two hex fields and the six decimal fields to their initial values
            and bind a function to handle changes to the values
        Create the sliders and set them to an initial value
        Set the sliders, color displays, and color check fields based on the hex values. */
    function initiate() {
        var passiveSupported = false;
        var scrollTimer = null;

        // Dragging / dropping colors is only supported on large screens (i.e. tablet, laptop, or PC)
        // as dragging wouldn't be intuitive on a mobile screen
        if ($("html").hasClass("full-screen")) {
            $(".draggable").propertyDragDrop({
                cloneClass: "clone",
                destinationCanReceiveClass: "dest-can-receive",
                dropTargetClass: "droppable",
                bodyDraggingClass: "dragging",
                didDrop: handleDropEvent,
                childrenIgnore: ".input-4, .input-6"
            });
        }

        $(".color-slider").mtRangeSlider({
            min: 0,
            max: 255,
            onChange: rgbSliderMoved
        });
        $(".hue-slider").mtRangeSlider({
            min: 0,
            max: 360,
            onChange: hsvSliderMoved
        });
        $(".sat-value-slider").mtRangeSlider({
            min: 0,
            max: 100,
            onChange: hsvSliderMoved
        });
        $(".opacity-slider").mtRangeSlider({
            min: 0,
            max: 100,
            onChange: opacitySliderMoved
        });
        // Handles for positioning Sliders
        frSliderHandle = $("#fc-red").data("mtRangeSlider");
        fgSliderHandle = $("#fc-green").data("mtRangeSlider");
        fbSliderHandle = $("#fc-blue").data("mtRangeSlider");
        fhSliderHandle = $("#fc-hue").data("mtRangeSlider");
        fsSliderHandle = $("#fc-saturation").data("mtRangeSlider");
        fvSliderHandle = $("#fc-value").data("mtRangeSlider");
        foSliderHandle = $("#fc-opacity").data("mtRangeSlider");
        brSliderHandle = $("#bc-red").data("mtRangeSlider");
        bgSliderHandle = $("#bc-green").data("mtRangeSlider");
        bbSliderHandle = $("#bc-blue").data("mtRangeSlider");
        bhSliderHandle = $("#bc-hue").data("mtRangeSlider");
        bsSliderHandle = $("#bc-saturation").data("mtRangeSlider");
        bvSliderHandle = $("#bc-value").data("mtRangeSlider");
        // Handles for getting SliderHandle values
        frSliderElement = doc.getElementById("fc-red");
        fgSliderElement = doc.getElementById("fc-green");
        fbSliderElement = doc.getElementById("fc-blue");
        fhSliderElement = doc.getElementById("fc-hue");
        fsSliderElement = doc.getElementById("fc-saturation");
        fvSliderElement = doc.getElementById("fc-value");
        foSliderElement = doc.getElementById("fc-opacity");
        brSliderElement = doc.getElementById("bc-red");
        bgSliderElement = doc.getElementById("bc-green");
        bbSliderElement = doc.getElementById("bc-blue");
        bhSliderElement = doc.getElementById("bc-hue");
        bsSliderElement = doc.getElementById("bc-saturation");
        bvSliderElement = doc.getElementById("bc-value");
        // Set the initial values to the input boxes and bind the change handlers
        $("#fc").val("0024A7").on("focus mouseup", function (event) {
            event.target.select();
        }).change(hexInputBoxChanged);
        $("#bc").val("FFFFE7").on("focus", function (event) {
            event.target.select();
        }).change(hexInputBoxChanged);
        $("#fc-r").val("0").on("focus mouseup", function (event) {
            event.target.select();
        }).change(rgbInputBoxChanged);
        $("#fc-g").val("36").on("focus mouseup", function (event) {
            event.target.select();
        }).change(rgbInputBoxChanged);
        $("#fc-b").val("167").on("focus mouseup", function (event) {
            event.target.select();
        }).change(rgbInputBoxChanged);
        $("#fc-orgb").val("100").on("focus mouseup", function (event) {
            event.target.select();
        }).change(opacityInputBoxChangedRGB);
        $("#bc-r").val("255").on("focus mouseup", function (event) {
            event.target.select();
        }).change(rgbInputBoxChanged);
        $("#bc-g").val("255").on("focus mouseup", function (event) {
            event.target.select();
        }).change(rgbInputBoxChanged);
        $("#bc-b").val("231").on("focus mouseup", function (event) {
            event.target.select();
        }).change(rgbInputBoxChanged);
        $("#fc-h").val("227").on("focus mouseup", function (event) {
            event.target.select();
        }).change(hueInputBoxChanged);
        $("#fc-s").val("100").on("focus mouseup", function (event) {
            event.target.select();
        }).change(svInputBoxChanged);
        $("#fc-v").val("65").on("focus mouseup", function (event) {
            event.target.select();
        }).change(svInputBoxChanged);
        $("#fc-ohsv").val("100").on("focus mouseup", function (event) {
            event.target.select();
        }).change(opacityInputBoxChangedHSV);
        $("#bc-h").val("60").on("focus mouseup", function (event) {
            event.target.select();
        }).change(hueInputBoxChanged);
        $("#bc-s").val("9").on("focus mouseup", function (event) {
            event.target.select();
        }).change(svInputBoxChanged);
        $("#bc-v").val("100").on("focus mouseup", function (event) {
            event.target.select();
        }).change(svInputBoxChanged);
        // Handles for getting & setting the values for the color input boxes
        // iOS / Safari won't support selecting - tried fcVal.setSelectionRange(0, 6); but didn't work
        fcVal = doc.getElementById("fc");
        bcVal = doc.getElementById("bc");
        fcRVal = doc.getElementById("fc-r");
        fcGVal = doc.getElementById("fc-g");
        fcBVal = doc.getElementById("fc-b");
        fcOrgb = doc.getElementById("fc-orgb");
        bcRVal = doc.getElementById("bc-r");
        bcGVal = doc.getElementById("bc-g");
        bcBVal = doc.getElementById("bc-b");
        fcHVal = doc.getElementById("fc-h");
        fcSVal = doc.getElementById("fc-s");
        fcVVal = doc.getElementById("fc-v");
        fcOhsv = doc.getElementById("fc-ohsv");
        bcHVal = doc.getElementById("bc-h");
        bcSVal = doc.getElementById("bc-s");
        bcVVal = doc.getElementById("bc-v");
        // jQuery handles for setting the background and text colors for the two color table divs
        $fcolorResult = $("#fcolor-result");
        $bcolorResult = $("#bcolor-result");
        // jQuery handle for setting the evaluation (e.g. good & green background)
        $cResult = $("#c-result");

        // jQuery handles for setting what level is good
        $overlayComplianceLevel = $("#overlay-compliance-level");
        $complianceMenu = $("#compliance-menu");
        $complianceLevel = $("#compliance-level");
        $complianceLevel.on("click", function (event) {
            event.stopPropagation();
            if ($overlayComplianceLevel.is(":hidden")) {
                $overlayComplianceLevel.show();
                $complianceLevel.addClass("flip");
                $complianceMenu.slideDown();
            } else {
                $overlayComplianceLevel.hide();
                $complianceLevel.removeClass("flip");
                $complianceMenu.slideUp();
            }
        });

        $overlayComplianceLevel.on("click", function () {
            $overlayComplianceLevel.hide();
            $complianceLevel.removeClass("flip");
            $complianceMenu.slideUp();
        });

        $("#user-selectable-link").on("click", function () {
            $overlayComplianceLevel.hide();
            $complianceLevel.removeClass("flip");
            $complianceMenu.slideUp();
        });

        // jQuery handles for the compliance level selectors
        $complianceLevel1 = $("#wcag-1");
        $complianceLevel2 = $("#wcag-aaa");
        $complianceLevel3 = $("#wcag-aa");
        $complianceLevel1.on("click", {level: 1}, complianceLevel);
        $complianceLevel2.on("click", {level: 2}, complianceLevel);
        $complianceLevel3.on("click", {level: 3}, complianceLevel);

        $reminderCheckBox = $("#reminderCheckbox");
        $reminderCheckBox.on("change", changeNotice);

        // jQuery handle for setting the background and text colors for the sample area
        $analysisDescription = $(".analysis-description");
        // Handle for setting the opacity for the sample area(s)
        $sampleText = $(".sample-text");
        // Handles for setting the analysis result values
        contrastRatio = doc.getElementById("contrast-ratio");
        cDiffVal = doc.getElementById("c-diff");
        bDiffVal = doc.getElementById("b-diff");
        w2b = doc.getElementById("w2b");
        w2a = doc.getElementById("w2a");
        w2aaab = doc.getElementById("w2aaab");
        w2aaaa = doc.getElementById("w2aaaa");
        opacityColor = doc.getElementById("opacity-color");
        // Click handlers for the five color combination buttons
        $("#color-combo-1").on("click", complementary);
        $("#color-combo-2").on("click", analogous);
        $("#color-combo-3").on("click", split);
        $("#color-combo-4").on("click", triadic);
        $("#color-combo-5").on("click", tetradic);
        // Get the stored color data for the color samples
        loadColorsFromStorage();
        updateColorsDisplay();
        updateSliderPositions();
        complianceLevel("initiate");

        $(".nav-scroll").on("click.smoothscroll", function (event) {
            var target;
            var offset;

            event.preventDefault();
            target = event.target.hash;
            offset = $(target).offset();
            $("html, body").stop().animate({
                "scrollTop": offset.top
            }, 500, "swing", function () {
                win.location.hash = target;
            });
        });

        /* Monitor the scroll position, and if far enough down the page, change the navigation */
        strCurrentSection = "analyzer"; // Initialize the value to the analyzer section (var gets updated when the section changes)
        instructionTargetTop = $("#section-middle").offset().top - 50;
        aboutTargetTop = $("#section-bottom").offset().top - 50;

        try {
            var options = Object.defineProperty({}, "passive", {
                get: function() {
                passiveSupported = true;
                }
            });

            win.addEventListener("test", options, options);
            win.removeEventListener("test", options, options);
        } catch(err) {
            passiveSupported = false;
        }

        // Ignore scroll events as long as a scrollHandler execution is in the queue
        function scrollThrottler() {
            if (!scrollTimer) {
                scrollTimer = win.setTimeout(function () {
                    scrollTimer = null;
                    scrollMonitor();
                // The scrollMonitor will execute at a rate of 30fps
                }, 33);
            }
        }

        // Only do scroll listening if the browser supports win.pageYOffset (IE8 and older don't)
        if (win.pageXOffset !== undefined) {
            win.addEventListener("scroll", scrollThrottler,
                passiveSupported ? { passive: true } : false);
            // Mobile devices will fire a resize event when the URL bar is hidden or shown
            win.addEventListener("resize", scrollThrottler);
            // Call scrollThrottler one time to be sure the page is adjusted if the page is not at the top (Firefox wasn't consistant)
            scrollThrottler();
        }

    }

    initiate();
}(jQuery, window, document));